import './SectionCardBody.scss';
import { PropsWithChildren, ReactNode } from 'react';
import { EmptyState } from '@Components/EmptyState';
import { Spinner } from '@Components/Spinner/Spinner';

interface SectionCardBodyProps extends PropsWithChildren {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  errorCopy: string;
  emptyCopy?: string;
  emptyAction?: ReactNode;
}

export const SectionCardBody = ({
  isLoading,
  isError,
  isEmpty,
  errorCopy,
  emptyCopy,
  emptyAction,
  children
}: SectionCardBodyProps) => {
  if (isLoading) {
    return (
      <div className='section-card-status'>
        <Spinner size={20} />
      </div>
    );
  }
  // A failed refetch keeps the cached content on screen.
  if (isError && isEmpty) {
    return <div className='section-card-status error'>{errorCopy}</div>;
  }
  if (isEmpty) {
    return (
      <EmptyState className='onboarding-section-card-empty-state' description={emptyCopy}>
        {emptyAction}
      </EmptyState>
    );
  }
  return <>{children}</>;
};
